import AuthBase from "../AuthBase";
import {useContext, useEffect, useRef, useState} from "react";
import {useNavigate, useParams} from "react-router";
import {
    Avatar,
    Grid,
    Stack,
} from "@mui/material";
import ConfigContext from "../../context/ConfigContext";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import userTemplate from "./UserTemplate";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import DinoDialog from "../../components/Dialog";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import Loading from "../../components/Loading";
import General from "./components/General";
import ProfilePicture from "./components/ProfilePicture";
import Services from "./components/Services";
import {getImageUrl} from "../../utils/UrlUtils";
import Leaves from "./components/Leaves";
import {useSnackbar} from "notistack";
import DeleteColleagueData from "./components/DeleteColleagueData";
import WorkHours from "./components/WorkHours";
import {hasPermission} from "../../utils/permissionUtils";
import {AuthContext} from "../../context/AuthContext";
import useColleagueQueries from "../../hooks/queries/useColleagueQueries";


const ColleagueDetail = () => {
    const {baseUrl} = useContext(ConfigContext)

    const [colleagueDeleteDialog, setColleagueDeleteDialog] = useState(false)
    const deleteRef = useRef(null)
    const {enqueueSnackbar} = useSnackbar()
    const params = useParams()
    const navigate = useNavigate()
    const {getUser} = useContext(AuthContext)
    const user = getUser()

    const {useColleagueQuery, updateColleagueMutation, deleteUserMutation} = useColleagueQueries()
    const {data: colleague, isPending: colleagueLoading} = useColleagueQuery(params.colleagueId)

    if (colleagueLoading) return <Loading isLoading />

    return <AuthBase label={colleague?.name}>
        <div className="main">
            <Button variant='text' startIcon={<ArrowBackIosNewRoundedIcon/>}
                    onClick={() => navigate(`/colleagues`)}>vissza</Button>
            <Grid container spacing={2}>

                {/*Headline*/}
                <Grid item xs={12}>
                    <div className="white-card">
                        <Stack direction='row' style={{justifyContent: 'space-between'}}>
                            <Stack direction='row' spacing={2}>
                                <Avatar src={getImageUrl(colleague?.profile_picture, baseUrl)}
                                        sx={{width: 90, height: 90}}/>
                                <Stack spacing={1} style={{alignSelf: 'center'}}>
                                    <Typography variant='headline6'>{colleague?.name}</Typography>
                                    <Typography variant='body1' color='#536B74'>{colleague?.title}</Typography>
                                </Stack>
                            </Stack>
                            <IconButton
                                disabled={hasPermission(user, "colleague", "remove", colleague)}
                                sx={{
                                    width: 50,
                                    height: 50,
                                    color: 'primary.main',
                                    alignSelf: 'center'
                                }}
                                onClick={() => setColleagueDeleteDialog(true)}>
                                <DeleteIcon/>
                            </IconButton>
                        </Stack>
                    </div>
                </Grid>

                {/*General data*/}
                <Grid item xs={12} md={6}>
                    <div className="white-card">
                        <Typography variant='subtitle1'>Általános adatok</Typography>
                        <Typography variant='body2' color='#536B74'>
                            Add meg a kolléga adatait!
                        </Typography>
                        <General
                            data={colleague}
                            handleSubmit={data => updateColleagueMutation.mutate({id: params.colleagueId, data})}
                        />
                    </div>
                </Grid>

                {/*Profile picture*/}
                <Grid item xs={12} md={6}>
                    <div className="white-card">
                        <Typography variant='subtitle1'>Kolléga profilképe</Typography>
                        <Typography variant='body2' color='#536B74'>
                            Töltsd fel a kolléga profilképét! (Ez a kép fog megjelenni a foglalási felületen is!)
                        </Typography>
                        <ProfilePicture
                            data={colleague}
                            handleSubmit={data =>  updateColleagueMutation.mutate({id: params.colleagueId, data})}
                        />
                    </div>
                </Grid>

                {/*Services*/}
                <Grid item xs={12} md={12}>
                    <Services/>
                </Grid>

                {/*Work hours*/}
                <Grid item xs={12} md={12}>
                    <WorkHours userId={params?.colleagueId}/>
                </Grid>

                {/*Leaves*/}
                <Grid item xs={12} md={12}>
                    <Leaves colleagueId={params?.colleagueId}/>
                </Grid>
            </Grid>
        </div>

        <DinoDialog open={colleagueDeleteDialog}
                    title='Kolléga törlése'
                    subtitle='Minden hozzá tartozó adat el fog veszni, foglalások, árak, stb...!'
                    handleClose={() => setColleagueDeleteDialog(false)}
                    actions={<Stack direction='row' spacing={1}>
                        <Button
                            variant='outlined'
                            onClick={() => setColleagueDeleteDialog(false)}>
                            Mégsem
                        </Button>
                        <Button
                            variant='contained'
                            onClick={() => {
                                const data = deleteRef.current.getData()
                                if (data) {
                                    setColleagueDeleteDialog(false)
                                    deleteUserMutation.mutate(params.colleagueId, {onSuccess: () => navigate('/colleagues')})
                                }
                            }} endIcon={<DeleteRoundedIcon/>}>
                            Törlés
                        </Button>
                    </Stack>}>
            <DeleteColleagueData reference={deleteRef}/>
        </DinoDialog>

        {/*<Prompt*/}
        {/*    when={hasUnsavedChanges}*/}
        {/*    message="Elmentetlen változtatásaid vannak, biztosan elmész erről az oldalról?"*/}
        {/*/>*/}

        {/*<Loading isLoading={loading}/>*/}
    </AuthBase>
}

export default ColleagueDetail